/*  main.js
    Main routing functions of the SPA.
    by Guy E. White <guw968@g.harvard.edu>
*/

import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import HomePage from './components/pages/HomePage.vue';
import ChoosePage from './components/pages/ChoosePage.vue';
import SeeAllTestsPage from './components/pages/SeeAllTestsPage.vue';
import TestPage from './components/pages/TestPage.vue';
import SuggestATestPage  from './components/pages/SuggestATestPage.vue';
import MyTestsPage  from './components/pages/MyTestsPage.vue';

// State management
import store from '@/common/store';

// Form validation
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

Vue.use(VueRouter);

Vue.config.productionTip = false

const routes = [
  { path: '/', component: HomePage, name: 'home' },
  { path: '/choose', component: ChoosePage, name: 'choose a statistical test' },
  { path: '/test/:slug', component: TestPage, name: 'test', props: true },
  { path: '/alltests', component: SeeAllTestsPage, name: 'see all tests' },
  { path: '/suggest', component: SuggestATestPage, name: 'suggest a test' },
  { path: '/mytests', component: MyTestsPage, name: 'my tests' }
];

const router = new VueRouter({
    routes: routes,
    mode: 'history'
})

new Vue({
    store: store,
    router: router, // <-- NEW
    render: h => h(App),
}).$mount('#app')
